<script lang="ts">
  import { Accessibility } from '$components/Icons';
  import { modals } from '$lib/stores/modals';
  import { isHrefExternal } from '$lib/utils/links';
  import {
    useEncodeDataAttribute,
    type ContentSourceMap,
    type StudioPathLike
  } from '@sanity/svelte-loader';
  import { sanityStudioURL } from '$lib/client';

  export let links: { url: string; text: string }[];
  export let sourceMap: ContentSourceMap | undefined = undefined;
  export let path: StudioPathLike = [];

  $: encodeDataAttribute = useEncodeDataAttribute(links, sourceMap, sanityStudioURL);
</script>

<nav>
  {#each links as link, index}
    <a
      href={link.url}
      target={isHrefExternal(link.url) ? '_blank' : undefined}
      data-sveltekit-reload={link.url.startsWith('/careers') ? true : null}
      rel="noreferrer noopener"
      tabIndex="0"
      data-sanity={encodeDataAttribute([...path, index, 'text'])}
    >
      {link.text}
    </a>
  {/each}
  <button
    class="modal-toggle accessibility"
    aria-label="Open accessibility settings"
    on:click={() => modals.open('accessibility')}
  >
    <div class="icon">
      <Accessibility />
    </div>
  </button>
</nav>

<style lang="scss">
  @import 'src/scss/landing.scss';

  nav {
    display: flex;
    align-items: center;
    padding: 0;
    justify-content: space-between;
  }
  a {
    @include clickable;
    @include animatedLink(1px);
    font-family: var(--font-family-primary);
    font-weight: 700;
    font-size: 14px;
    font-style: normal;
    line-height: 180%;
    text-transform: uppercase;
  }

  .modal-toggle {
    @include clickable;
    @include fadeSVG;
    cursor: pointer;
    display: flex;
    background-color: transparent;
    border: none;
    color: var(--twist-color-gray-100);
    border-radius: 1000px;
    padding: 5px 6px;
    margin-left: -5px;

    &.accessibility {
      display: inline-flex;

      .icon {
        display: flex;
        justify-content: center;
        height: 20px;
        width: 16px;
      }
    }
  }

  @media screen and (min-width: 768px) {
    nav {
      display: grid;
      grid-auto-flow: column;
      gap: 20px;
    }
    a {
      font-size: 16px;
    }
  }

  @media screen and (min-width: 1024px) {
    nav {
      gap: 24px;
    }
    a {
      font-size: 20px;
    }
    .modal-toggle.accessibility .icon {
      width: 20px;
      height: 25px;
    }
  }
</style>
